import type { Release } from '../releases.ts';

export default {
  version: '0.9.3',
  date: '2026-09-30',
  title: 'Storage agents behind the web tier',
  summary: [
    'Helm ingress settings for large agent transfers and long-polls',
    'Fixed: storage agents can enrol through the web tier',
    'Fixed: an agent pointed at the wrong address explains the problem',
  ],
  features: ['Ingress settings in the Helm chart for large agent transfers and long-polls'],
  fixes: [
    'Storage agents can enrol through the web tier (it now forwards /agent/ to the API)',
    'An agent pointed at the wrong address explains the problem instead of crashing',
  ],
} satisfies Release;
